import { CommonModule } from "@angular/common";
import { Component, inject } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import {
  MatDialogModule,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";

export interface ConfirmationModalData {
  title: string;
  description?: string;
  confirmText?: string;
  cancelText?: string;
  confirmButtonColor?: "primary" | "warn" | "success";
  titleColor?: "gray" | "primary";
}

export type ConfirmationModalResult = "confirm" | "cancel" | "dismiss";

@Component({
  selector: "app-confirmation-modal",
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule],
  templateUrl: "./confirmation-modal.component.html",
  styleUrl: "./confirmation-modal.component.scss",
})
export class ConfirmationModalComponent {
  readonly dialogRef = inject(MatDialogRef<ConfirmationModalComponent>);
  readonly data = inject<ConfirmationModalData>(MAT_DIALOG_DATA);

  readonly title = this.data.title;
  readonly description = this.data.description;
  readonly confirmText = this.data.confirmText ?? "Confirm";
  readonly cancelText = this.data.cancelText ?? "Cancel";
  readonly confirmButtonColor = this.data.confirmButtonColor ?? "warn";
  readonly titleColor = this.data.titleColor ?? "primary";

  onCancel(): void {
    this.dialogRef.close("cancel");
  }

  onConfirm(): void {
    this.dialogRef.close("confirm");
  }

  onKeydown(event: KeyboardEvent): void {
    if (event.key === "Escape") {
      this.dialogRef.close("dismiss");
    }
  }
}
